import axios from "axios";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
// import './vehicleSelect.scss'

interface IPROPS {
  fetchVehicle: any;
  setVehicleAddClicked: any;
}

const VehicleRegistration: React.FC<IPROPS> = ({
  fetchVehicle,
  setVehicleAddClicked,
}) => {
  const [getBrands, setGetBrands] = useState([]);
  const [getModels, setGetModels] = useState([]);
  const [getFuelType, setGetFuelType] = useState([]);
  const [vehicleAdded, setVehicleAdded] = useState(false);

  const [checkBrandId, setCheckBrandId] = useState("");

  const [formData, setFormData] = useState({
    brand: "",
    model: "",
    make_year: "",
    fuel: "",
    vehicle_number: "",
  });

  const token = localStorage.getItem("customer-token");
  const fetchingTenant = window.location.hostname.split(".")[0];
  const apiPort = process.env.REACT_APP_API_PROTOCOL;

  useEffect(() => {
    const fetchBrands = async () => {
      const response = await axios.get(
        `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/inventory/brands/`,
      );
      setGetBrands(response?.data);
    };
    fetchBrands();
  }, []);

  const handleInputChange = (field: any, value: any) => {
    console.log(value, "fielddd");
    // setCheckBrandId(value)
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleBrandChange = (e) => {
    const selectedBrandId = e.target.value;
    setFormData((prev) => ({
      ...prev,
      brand: selectedBrandId,
      model: "", // Optional: Reset model when brand changes
    }));
    setCheckBrandId(selectedBrandId); // triggers useEffect
  };

  useEffect(() => {
    if (checkBrandId) {
      const fetchModels = async () => {
        const response = await axios.get(
          `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/inventory/models/?brand=${checkBrandId}`,
        );
        setGetModels(response?.data);
      };
      fetchModels();
    }
  }, [checkBrandId]);

  useEffect(() => {
    const fetchFuelType = async () => {
      const response = await axios.get(
        `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/inventory/fuel-types/`,
      );
      setGetFuelType(response?.data);
    };
    fetchFuelType();
  }, []);

  const years = Array.from({ length: 25 }, (_, i) =>
    (new Date().getFullYear() - i).toString(),
  );

  useEffect(() => {
    setFormData({
      brand: "",
      model: "",
      make_year: "",
      fuel: "",
      vehicle_number: "",
    });
  }, []);

  const handleSave = async () => {
    // Basic validation
    if (
      !formData.brand ||
      !formData.model ||
      !formData.make_year ||
      !formData.fuel ||
      !formData.vehicle_number
    ) {
      toast.error("Please fill all required fields");
      return;
    }

    // Additional validation for registration number format
    const regNumberPattern = /^[A-Z]{2}[0-9]{2}[A-Z]{2}[0-9]{4}$/;

    if (!regNumberPattern.test(formData.vehicle_number.toUpperCase())) {
      alert("Please enter a valid registration number (e.g., DL14CH2166)");
      return;
    }

    try {
      const response = await axios.post(
        `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/gc/vehicles/`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response?.data) {
        setVehicleAdded(true);
        setVehicleAddClicked(false);
        setFormData({
          brand: "",
          model: "",
          make_year: "",
          fuel: "",
          vehicle_number: "",
        });
      }

      // onClose()
      toast.success("Vehicle added successfully!");
      fetchVehicle();

      // onSave(formData);
    } catch (error) {
      console.error(
        "Error saving vehicle:",
        error?.response?.data?.errors?.vehicle_number,
      );
      toast.error("Failed to save vehicle");
    }
  };

  return (
    <div>
      <div
        className="customer-vehicle-info__modal-content"
        style={{ padding: "0" }}
      >
        <div
          className="customer-vehicle-info__form-row"
          style={{ marginBottom: "15px" }}
        >
          <div className="customer-vehicle-info__form-group">
            <label
              className="customer-vehicle-info__label"
              style={{ marginBottom: "0px" }}
            >
              Brand*
            </label>
            <select
              style={{ borderRadius: "20px" }}
              className="customer-vehicle-info__select"
              value={formData.brand}
              onChange={handleBrandChange}
            >
              <option value="">Select</option>
              {getBrands?.map((make: any) => (
                <option key={make?.id} value={make?.id}>
                  {make?.name}
                </option>
              ))}
            </select>
          </div>

          <div className="customer-vehicle-info__form-group">
            <label
              className="customer-vehicle-info__label"
              style={{ marginBottom: "0px" }}
            >
              Model*
            </label>
            <select
              style={{ borderRadius: "20px" }}
              className="customer-vehicle-info__select"
              value={formData.model}
              onChange={(e) =>
                handleInputChange("model", Number(e.target.value))
              }
            >
              <option value="">Select</option>
              {getModels?.map((model) => (
                <option key={model.id} value={model.id}>
                  {model.name}
                </option>
              ))}
            </select>
          </div>

          <div className="customer-vehicle-info__form-group">
            <label
              className="customer-vehicle-info__label"
              style={{ marginBottom: "0px" }}
            >
              Year*
            </label>
            <select
              style={{ borderRadius: "20px" }}
              className="customer-vehicle-info__select"
              value={formData.make_year}
              onChange={(e) => handleInputChange("make_year", e.target.value)}
            >
              <option value="">Select</option>
              {years.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="customer-vehicle-info__form-row">
          <div className="customer-vehicle-info__form-group">
            <label className="customer-vehicle-info__label">Fuel Type*</label>
            <select
              style={{ borderRadius: "20px" }}
              className="customer-vehicle-info__select"
              value={formData.fuel}
              onChange={(e) => handleInputChange("fuel", e.target.value)}
            >
              <option value="">Select</option>
              {getFuelType.map((fuel: any) => (
                <option key={fuel?.id} value={fuel?.id}>
                  {fuel?.type}
                </option>
              ))}
            </select>
          </div>

          <div className="customer-vehicle-info__form-group">
            <label className="customer-vehicle-info__label">
              Vehicle Registration Number*
            </label>
            <input
              style={{ borderRadius: "20px" }}
              type="text"
              className="customer-vehicle-info__input"
              value={formData.vehicle_number}
              onChange={(e) =>
                handleInputChange("vehicle_number", e.target.value)
              }
              placeholder="Enter Registration Number"
            />
          </div>
        </div>
      </div>
      <div className="customer-vehicle-info__modal-footer">
        <button
          className="customer-vehicle-info__modal-btn vehicle-info__modal-btn--save"
          style={{
            borderRadius: "20px",
            background: "#FF5722",
            color: "white",
          }}
          onClick={handleSave}
        >
          Save
        </button>
        <button
          className="customer-vehicle-info__modal-btn vehicle-info__modal-btn--cancel"
          onClick={() => setVehicleAddClicked(false)}
          style={{ borderRadius: "20px" }}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default VehicleRegistration;
